import {getAuth, getMessage} from '../reducers/filters';
import {mapCode} from "../service/serverCodeMapper";
export const DEFAULT_TIME_OUT= 120000;


function getPort(filterPort, protocol) {
    if (protocol === 'https') {
        switch(filterPort) {
            case '8001':
                return '/russian';
            case '8002':
                return '/japan';
            case '8003':
                return '/kazakh';
            default:
                return '';
        }
    }
    return ':' + filterPort;
}

export default (filter, onResponse, reject, user, data, paginationEventType, isAuth, _id, count)=>{
    const server = isAuth ? filter.authUrl : filter.statServerUrl;
    const protocol = server === 'localhost' ? 'http' : 'https';
    let port = getPort(filter.port, protocol);
    const url = protocol + '://' + server + port + filter.path;
    console.log(filter);
    console.log(url);
    const message=getMessage(filter, data, paginationEventType, user, _id, count);
    console.log(message);

    const auth = getAuth(filter,user);

    const xhttp=new XMLHttpRequest();
    try {
        xhttp.open("POST", url, true);
    } catch(e) {
        gotError("Неверный сервер или порт");
        return;
    }

    if (auth) {
        xhttp.setRequestHeader("Authorization", auth);
    }
    console.log(auth)

    xhttp.setRequestHeader("Content-type", "application/json; charset=utf8");
    xhttp.setRequestHeader('Access-Control-Allow-Origin', '*');
    xhttp.setRequestHeader('Access-Control-Allow-Headers', '*');
    xhttp.setRequestHeader('Access-Control-Allow-Methods', 'GET, POST, PATCH, PUT, DELETE, OPTIONS');
    xhttp.timeout = DEFAULT_TIME_OUT;
    xhttp.ontimeout = function() {
        reject("Превышено время ожидания ответа от сервера");
    }
    xhttp.onreadystatechange = () =>{
        if (xhttp.readyState === xhttp.DONE) {
            console.log(xhttp.status);
            if(xhttp.status <200 || xhttp.status >= 400) {
                reject(mapCode(xhttp.status, xhttp.response));
            }
            else {
                onResponse(xhttp.status,xhttp.response);
            }
        }
    };
    try {
        xhttp.send(JSON.stringify(message));
    } catch (e) {
        console.log(e)
    }

};



/*export function urlRequest(filter, path, message, onResponse,reject){
    const url='http://'+ filter.url + ':' + filter.port + path;
    console.log(url);
    console.log(message);
    const xhttp=new XMLHttpRequest();
    xhttp.open("POST", url, true);
    xhttp.setRequestHeader("Content-type", "application/json; charset=utf8");
    xhttp.setRequestHeader('Access-Control-Allow-Origin', '*');
    xhttp.setRequestHeader('Access-Control-Allow-Headers', '*');
    xhttp.setRequestHeader('Access-Control-Allow-Methods', 'GET, POST, PATCH, PUT, DELETE, OPTIONS');
    xhttp.timeout = DEFAULT_TIME_OUT;
    xhttp.onreadystatechange = () =>{
        if (xhttp.readyState === xhttp.DONE) {
            console.log(xhttp.status);
            if(xhttp.status <200 || xhttp.status >= 400) reject(xhttp.status, xhttp.responseText);
            else onResponse(xhttp.status,xhttp.responseText);
        }
    };
    xhttp.send(JSON.stringify(message));
};*/